/** Ask the host page to keep the results view expanded after an action. */
export const maintainExpandMode = (): void => {
  const event = new CustomEvent('cotizador:results-view', {
    detail: {
      action: 'expand',
      message: 'Mantener modo expandido después de la acción en EmissionSuccess'
    }
  });
  document.body.dispatchEvent(event);
};
